import { ensureLatAndLng } from "../modules/project";
import { createSelector } from "reselect";
import { getUniqueCategoriesFromShops } from "../modules/getUniqueCategoriesFromShops";
const initialState = {
  geojson: null,
  shops: [],
  cases: {},
  riskByPostcode: {},
  suburbsByPostcode: {},
  maxRisk: 0,
  minRisk: 0,
  maxCases: 0,
  latestDate: ''
};
export default (state = initialState, action) => {
  switch (action.type) {
    case "SHOP:ALL:REQUEST":
      return state;
    case "CASES:ALL:REQUEST":
      return state;
    case "GEOJSON:REQUEST": {
      return { ...state, geojson: null };
    }
    case "GEOJSON:SUCCESS":
      return { ...state, geojson: action.payload };
    case "GEOJSON:FAILURE":
    case "SHOP:ALL:FAILURE":
      return { ...state, error: action.payload };
    case "SUBURBS:SUCCESS":
      const suburbData = action.payload;
      return { ...state, suburbsByPostcode: suburbData }
    case "RISK:SUCCESS":
      const riskData = action.payload;
      let maximumRisk = 0;
      let minimumRisk = 1000;
      Object.keys(riskData).forEach(elem => {
        let postCodeRisk = riskData[elem]['avg_risk'];
        if (postCodeRisk > maximumRisk) {
          maximumRisk = postCodeRisk;
        }
      })
      Object.keys(riskData).forEach(elem => {
        let postCodeRisk = riskData[elem]['avg_risk'];
        if (postCodeRisk < minimumRisk) {
          minimumRisk = postCodeRisk;
        }
      })
      // console.log("maxrisk", maximumRisk, "minimumRisk", minimumRisk);
      return { ...state, maxRisk: maximumRisk, minRisk: minimumRisk, riskByPostcode: riskData };
    case "CASES:ALL:SUCCESS":
      const casesByPostcode = {};
      let max = 0;
      let latest = new Date(action.payload.map(function(e) { return e.notification_date; }).sort().reverse()[0]).toLocaleDateString();
      action.payload.forEach(element => {
        if (casesByPostcode[element.postcode]) {
          casesByPostcode[element.postcode].dates = [...casesByPostcode[element.postcode].dates, element.notification_date]
          if (casesByPostcode[element.postcode].dates.length > max) {
            max = casesByPostcode[element.postcode].dates.length;
          }
        } else {
          casesByPostcode[element.postcode] = { ...element, dates: [element.notification_date] }
        }
      });
      // console.log('latestDate', latest);
      return {
        ...state, cases: casesByPostcode, maxCases: max, latestDate: latest
      };
    case "SHOP:ALL:SUCCESS":
      const shopsWithLatLong = action.payload
        .filter(row => {
          if (!ensureLatAndLng(row)) {
            return false;
          } else {
            return true;
          }
        })
        .map(row => {
          const { category, ...rest } = row;
          const categories = category.split(",").map(cat => cat.trim());

          return { ...rest, categories: categories };
        });

      return {
        ...state,
        shops: shopsWithLatLong,
      };
    default:
      return state;
  }
};

// Anything that needs all shops calls this
// give it arguments, each one gets called with the whole state
export const selectAllShops = state => {
  return state.shops;
};

export const selectGeoJSON = state => state.geojson;

export const selectCases = state => state.cases;
export const selectRiskByPostcode = state => state.riskByPostcode;
export const selectMaxCases = state => state.maxCases;
export const selectLatestDate = state => state.latestDate;
export const selectMaxRisk = state => state.maxRisk;
export const selectMinRisk = state => state.minRisk;
export const selectSuburbsByPostcode = state => state.suburbsByPostcode;


// Select all shops that match the filters
export const selectFilteredProjects = (filterArray, state) => {
  const allShops = selectAllShops(state);

  if (filterArray.length < 1) {
    return [];
  }

  const filterByName = filterArray.reduce((acc, filter) => {
    acc[filter] = true;
    return acc;
  }, {});

  // Shops that have at least one of the filters
  const filteredShops = allShops.filter(shop => {
    return shop.categories.some(category => filterByName[category]);
  });

  return filteredShops;
};

// If you use createSelector, the results are memoized
export const selectAllCategories = createSelector(
  s => s.shops,
  shops => getUniqueCategoriesFromShops(shops)
);



// WEBPACK FOOTER //
// ./src/reducers/data.js